@if (
  {
    title: title(),
    description: description()
  };
  as STATE
) {
  <article class="default-modal-header">
    <h1 class="default-modal-header__title">{{ STATE.title }}</h1>
    <p *ngIf="STATE.description" class="default-modal-header__description">
      {{ STATE.description }}
    </p>
  </article>
}
